import { Button, Dialog, DialogActions, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import DropZone from "../../../commons/dropZone/DropZone";
import { StyledProgramaSeguridad } from "../../../styled/Obras";

const ProgramaSeguridad = ({ denominacion, nroObra, open, handleClose, handleConfirm, file, setFile }) => {
  const postLoading = useSelector((state) => state.obra.adjuntarProgramaSeguridad.loading)
  return (
    <Dialog open={open} onClose={handleClose}>
      <StyledProgramaSeguridad.TitleContainer>Programa de Seguridad</StyledProgramaSeguridad.TitleContainer>
      <StyledProgramaSeguridad.DialogContent>
        <Typography>
          <strong> Adjunte el programa de seguridad para el Nro de obra {nroObra} - {denominacion} </strong>
        </Typography>
        <StyledProgramaSeguridad.DropzoneContainer>
          <DropZone
            file={file}
            setFile={setFile}
            loading={false}
            maxFiles={1}
            extension=".PDF"
            accept={{
              "application/pdf": [".pdf"],
            }}
            dropZoneText="Arrastre aquí o haga click en el recuadro para importar información en formato PDF"
          />
        </StyledProgramaSeguridad.DropzoneContainer>

      </StyledProgramaSeguridad.DialogContent>
      <DialogActions style={{ margin: 10 }}>
        <Button onClick={handleClose} disabled={postLoading} color="primary">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} disabled={postLoading} color="primary" variant="contained">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
};


export default ProgramaSeguridad;